import { useState } from 'react';
import Medication from './medicalJournal/medication';
import Allergies from './medicalJournal/allergies';
import FamilyHistory from './medicalJournal/familyHistory';
import Vaccination from './medicalJournal/vaccination';
import Hospitalization from './medicalJournal/hospitalization';
import Surgery from './medicalJournal/surgery';
import BirthHistory from './medicalJournal/birthHistory';
import medicationIcon from '../../assets/medicines.png';
import allergiesIcon from '../../assets/bacteria.png';
import vaccineIcon from '../../assets/syringe.png';
import familyHistoryIcon from '../../assets/dna.png';
import hospitalizationIcon from '../../assets/hospital.png';
import surgeryIcon from '../../assets/operatingRoom.png';
import birthHistoryIcon from '../../assets/birthhistory.png';

const screens = ["medication", "allergies", "vaccination", "family history", "hospitalization", "surgery", "birth history"];

const Component = props => {
    const [currentScreen, setCurrentScreen] = useState("medication");
    
    const showScreen = () => {
        switch(currentScreen){
            case "allergies":
                return <Allergies uuid={props.uuid} allergies={props.allergies} setAllergies={props.setAllergies}/>;
            case "vaccination":
                return <Vaccination uuid={props.uuid} vaccination={props.vaccination} setVaccination={props.setVaccination}/>;
            case "family history":
                return <FamilyHistory uuid={props.uuid} familyHistory={props.familyHistory} setFamilyHistory={props.setFamilyHistory}/>;
            case "hospitalization":
                return <Hospitalization uuid={props.uuid} hospitalization={props.hospitalization} setHospitalization={props.setHospitalization}/>;
            case "surgery":
                return <Surgery uuid={props.uuid} surgery={props.surgery} setSurgery={props.setSurgery} />;
            case "birth history":
                return <BirthHistory uuid={props.uuid} birthHistory={props.birthHistory} setBirthHistory={props.setBirthHistory}/>;
            default:
                return <Medication uuid={props.uuid} medication={props.medication} setMedication={props.setMedication}/>;
        }
    };
    
    const getIcon = (screen) => {
        switch(screen){
            case "allergies":
                return <img src={allergiesIcon} width={29} height={29} alt="" />;
            case "vaccination":
                return <img src={vaccineIcon} width={26} height={26} alt="" />;
            case "family history":
                return <img src={familyHistoryIcon} width={25} height={30} alt="" />;
            case "hospitalization":
                return <img src={hospitalizationIcon} width={26} height={26} alt="" />;
            case "surgery":
                return <img src={surgeryIcon} width={27} height={24} alt="" />;
            case "birth history":
                return <img src={birthHistoryIcon} width={27} height={34} alt="" />;
            default:
                return <img src={medicationIcon} width={26} height={26} alt="" />;
        }
    };
    
    return (
        <div className="profile-mj-cont">
            <nav className="profile-mj-nav">
                <ul className="profile-mj-ul">
                    { screens.map(s=>(
                        <li
                            onClick={()=>setCurrentScreen(s)}
                            key={s}
                            className={`profile-mj-li ${s===currentScreen ? 'profile-mj-sel-li' : null}`}
                        >
                        <span className="profile-mj-icon">{getIcon(s)}</span>
                        {s}</li>
                    ))}
                </ul>
            </nav>
            <main className="profile-mj-main">
                { showScreen() }
            </main>
        </div>
    );
};

export default Component;